// extracted by mini-css-extract-plugin
export default {"hero":"Hero-module__hero--eGYx8","heroContent":"Hero-module__heroContent--klvlQ","heroSubtitle":"Hero-module__heroSubtitle--o4mc5","ctaButton":"Hero-module__ctaButton--tCObR"};